<template>
  <v-container style="width: 100%;">
    <router-link to="/settings/general/operating_regions">Operating Regions</router-link>
  </v-container>
</template>

<script>
// @ is an alias to /src
import General from "@/components/settings/general/General.vue";

export default {
  name: "general_settings",
  components: {
    General
  }
};
</script>
